import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var AppDriverService = /** @class */ (function () {
    function AppDriverService(http, config) {
        this.http = http;
        this.config = config;
    }
    AppDriverService.prototype.getDriverNewServices = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/drivers/services/assigned");
    };
    AppDriverService.prototype.getDriverOldServices = function (s) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/drivers/services/assigned?s=" + s);
    };
    AppDriverService.prototype.getDriverService = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/drivers/services/assigned/" + id);
    };
    AppDriverService.prototype.driverReply = function (request) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/drivers/services/reply", request);
    };
    AppDriverService.prototype.driverServiceTracking = function (request) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/drivers/services/tracking", request);
    };
    AppDriverService.prototype.pdf = function (id) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/document", { tipo_documento: 'driver_servizio', output: "PDF", id: id }, { responseType: "blob" });
    };
    AppDriverService.prototype.generateCartelloAutista = function (id) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/document", { tipo_documento: 'cartello_autista', output: "PDF", id: id }, { responseType: "blob" });
    };
    AppDriverService.ngInjectableDef = i0.defineInjectable({ factory: function AppDriverService_Factory() { return new AppDriverService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: AppDriverService, providedIn: "root" });
    return AppDriverService;
}());
export { AppDriverService };
